<template>
    <div>
        <b-card>
            <b-row>
                <div class="col-12 mt-16">
                    <b-form @submit.prevent="addUser" v-if="show">
                        <div style="background-color: rgb(97, 116, 152); height: 32px; border-radius: 4px;">
                            <h4 style="color: rgb(223, 227, 238); margin-left: 5px; font-weight: bold;">
                                Vehicle Information
                            </h4>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Category:" label-for="category_id">
                                    <b-form-select id="category_id" :state="validateField(category_id, 'number')" placeholder="Select category id" 
                                        v-model="category_id" :options="categories" required @change="filterBrands">
                                    </b-form-select>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Brand Name:" label-for="brand_id">
                                    <b-form-select id="brand_id" placeholder="Select brand id" :state="validateField(brand_id, 'number')" v-model="brand_id"
                                        :options="brands" required>
                                    </b-form-select>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Brand Model:" label-for="brand_model_id">
                                    <b-form-select id="brand_model_id" :state="validateField(brand_model_id, 'number')" placeholder="Select brand model"  
                                        v-model="brand_model_id" :options="brandModels" required>
                                    </b-form-select>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group label="Vehicle Color:" label-for="color">
                                <b-form-input
                                    id="color"
                                    v-model="color"
                                    :state="validateField(color)"
                                    placeholder="Enter vehicle color"
                                    required
                                ></b-form-input>
                                <b-form-invalid-feedback>
                                    Please enter a vehicle color.
                                </b-form-invalid-feedback>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group label="License Plate:" label-for="license_plate">
                                    <b-form-input id="license_plate" placeholder="Enter license plate" :state="validateField(license_plate)"
                                        v-model="license_plate"></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Engine Number: " label-for="engine_number">
                                    <b-form-input id="engine_number" placeholder="Enter engine number" :state="validateField(engine_number)"
                                        v-model="engine_number" required></b-form-input>
                                </b-form-group>
                            </div>

                            <!-- <div class="col-md-4 col-12">
                                <b-form-group label="Approve Status:" label-for="types">
                                    <b-form-input id="types" placeholder="Enter types" v-model="types"></b-form-input>
                                </b-form-group>
                            </div> -->


                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Approve Status:" label-for="types">
                                    <b-form-select id="types" v-model="types" :state="validateField(types)" :options="statusOptions"
                                        required></b-form-select>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group label="Registration Number:" label-for="registration_number">
                                    <b-form-input id="registration_number" :state="validateField(registration_number)" placeholder="Enter registration number" 
                                        v-model="registration_number"></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group label="Vehicle Year:" label-for="year">
                                    <b-form-input id="year" placeholder="Enter vehicle year" :state="validateField(year, 'number')"
                                        v-model="year"></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Vehicle Identification Number: "
                                    label-for="vin">
                                    <b-form-input id="vin" :state="validateField(vin)" placeholder="Enter vehicle identification number:"
                                        v-model="vin" required></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Unique Identification Code:" label-for="uic">
                                    <b-form-input id="uic" :state="validateField(uic)" placeholder="Enter unique identification code" v-model="uic" required></b-form-input>
                                </b-form-group>
                                </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Vehicle Status:" label-for="status">
                                    <b-form-input id="status" placeholder="Enter status" :state="validateField(status)" v-model="status"
                                        disabled></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Description:" label-for="description">
                                    <textarea class="form-control" type="text" id="description" placeholder="Enter description"  :class="{
                                        'is-invalid': validateField(description) === false,
                                        'is-valid': validateField(description) === true,
                                        }"
                                         v-model="description"
                                        required>
                                    </textarea>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Features:" label-for="features">
                                    <b-form-input id="features" placeholder="Enter feature" :state="validateField(features)" v-model="features" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="System No:" label-for="SystemNo">
                                    <b-form-input id="SystemNo" placeholder="Enter SystemNo" :state="validateField(SystemNo)"v-model="SystemNo" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Insurance Company Name" label-for="insurance_company_name">
                                    <b-form-input id="insurance_company_name" placeholder="Enter insurance company name" :state="validateField(insurance_company_name)"v-model="insurance_company_name" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Insurance Policy Number:" label-for="insurance_policy_number">
                                    <b-form-input id="insurance_policy_number" placeholder="Enter insurance policy number" :state="validateField(insurance_policy_number)"v-model="insurance_policy_number" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Insurance Expiration Date:" label-for="insurance_expiration_date">
                                    <b-form-input id="insurance_expiration_date" type="date" placeholder="Enter insurance expiration date" :state="validateField(insurance_expiration_date)"v-model="insurance_expiration_date" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="WOSS System Installation Date:"
                                    label-for="install_date">
                                    <b-form-input id="install_date" :state="validateField(install_date)" placeholder="Enter WOSS System Installation Date in the vehicle"
                                       type="datetime-local"  v-model="install_date" required></b-form-input>
                                </b-form-group>
                            </div>
                            <!-- <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Vehicle Images:" label-for="images">
                                    <input type="file" accept="image/*" multiple @change="onProfilePictureChange" />

                                    <div v-if="image && image.length" style="margin-left: 3px; margin-bottom: 15px">
                                        <img v-for="(image, index) in image" :key="index"
                                            :src="'https://wossdb.wossautoid.com/' + image" alt="Vehicle Image"
                                            width="100" height="100" style="margin-right: 10px" />
                                    </div>
                                    <div v-else>
                                        <span>No image available</span>
                                    </div>
                                </b-form-group>
                            </div> -->

                            <!-- Doucment code  here  -->

                            <!-- <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Documents:" label-for="documents">
                                    <input type="file" accept="image/*,.pdf" multiple @change="onDocumentChange" />
                                    <div v-if="documentPreviews.length">
                                        <div v-for="(preview, index) in documentPreviews" :key="index"
                                            class="document-item">
                                            <div v-if="preview.endsWith('.pdf')">
                                                <i class="fas fa-file-pdf"></i> PDF
                                            </div>
                                            <img v-else :src="preview" alt="Document" width="100" height="100" />

                                             
                                            <button @click="openDocumentModal(index)" type="button"
                                                class="btn btn-sm btn-primary">Change</button>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <span>
                                            No document available
                                        </span>
                                    </div>
                                </b-form-group>
                            </div> -->
                            <!-- Vehicle Images -->
                                <div class="col-md-4 col-12">
                                <b-form-group label="Vehicle Images:" label-class="font-weight-bold" description="Recommended size: 300x300px (JPG/PNG)">
                                    <div
                                    class="border rounded p-3 text-center"
                                    style="cursor: pointer; background: #f9f9f9;"
                                    @drop.prevent="onVehicleImageDrop"
                                    @dragover.prevent
                                    @click="$refs.vehicleImages.click()"
                                    >
                                    <div v-if="!imagePreviews.length">
                                        <i class="fas fa-cloud-upload-alt fa-2x text-muted"></i>
                                        <p class="mb-0">Drag & Drop or Click to Upload</p>
                                    </div>
                                    <div v-else class="d-flex flex-wrap justify-content-center">
                                        <div v-for="(preview, index) in imagePreviews" :key="index" class="m-1 text-center">
                                        <img
                                            :src="preview"
                                            class="img-thumbnail"
                                            style="max-height: 100px; max-width: 100px;"
                                        />
                                        <b-button
                                            size="sm"
                                            variant="danger"
                                            class="mt-1"
                                            @click.stop="removeVehicleImage(index)"
                                        >
                                            Remove
                                        </b-button>
                                        </div>
                                    </div>
                                    <input
                                        ref="vehicleImages"
                                        type="file"
                                        accept="image/*"
                                        multiple
                                        class="d-none"
                                        @change="onVehicleImagesChange"
                                    />
                                    </div>
                                    <b-form-invalid-feedback v-if="vehicleImageError" class="d-block text-danger">
                                    {{ vehicleImageError }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                                </div>

                                <!-- Vehicle Documents -->
                                <div class="col-md-4 col-12">
                                <b-form-group label="Documents:" label-class="font-weight-bold" description="Upload PDF/DOCX (Max 10MB)">
                                    <div
                                    class="border rounded p-3 text-center"
                                    style="cursor: pointer; background: #f9f9f9;"
                                    @drop.prevent="onVehicleDocumentDrop"
                                    @dragover.prevent
                                    @click="$refs.vehicleDocuments.click()"
                                    >
                                    <div v-if="!documentPreviews.length">
                                        <i class="fas fa-file-upload fa-2x text-muted"></i>
                                        <p class="mb-0">Drag & Drop or Click to Upload</p>
                                    </div>
                                    <div v-else class="d-flex flex-wrap justify-content-center">
                                        <div v-for="(preview, index) in documentPreviews" :key="index" class="m-2 text-center">
                                        <div v-if="preview.endsWith('.pdf')">
                                            <i class="fas fa-file-pdf fa-3x text-danger"></i>
                                            <p class="mb-0">
                                                {{ documentFiles[index] ? documentFiles[index].name : 'Existing PDF Document' }}
                                            </p>
                                        </div>
                                        <div v-else>
                                            <img
                                            :src="preview"
                                            class="img-thumbnail"
                                            style="max-height: 100px; max-width: 100px;"
                                            />
                                        </div>
                                        <b-button
                                            size="sm"
                                            variant="danger"
                                            class="mt-1"
                                            @click.stop="removeVehicleDocument(index)"
                                        >
                                            Remove
                                        </b-button>
                                        </div>
                                    </div>
                                    <input
                                        ref="vehicleDocuments"
                                        type="file"
                                        accept="image/*,.pdf"
                                        multiple
                                        class="d-none"
                                        @change="onVehicleDocumentsChange"
                                    />
                                    </div>
                                    <b-form-invalid-feedback v-if="vehicleDocumentError" class="d-block text-danger">
                                    {{ vehicleDocumentError }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                                </div>

                                <!-- Vehicle Automark Tattoos -->
                                <div class="col-12">
                                    <div style="background-color: rgb(97, 116, 152); height: 32px; border-radius: 4px;" class="mt-3 mb-3">
                                        <h4 style="color: rgb(223, 227, 238); margin-left: 5px; font-weight: bold;">
                                            Vehicle Automark Tattoos
                                        </h4>
                                    </div>
                                    <p class="text-muted small mb-3">
                                        Add each tattoo location with a title and photo so inspectors can find and verify them on the vehicle.
                                    </p>
                                </div>

                                <div v-for="(tattoo, index) in tattoos" :key="'tattoo-' + index" class="col-12">
                                    <b-card class="mb-3 border">
                                        <b-row>
                                            <div class="col-md-4 col-12">
                                                <b-form-group label="Location Title:" :label-for="'tattoo-title-' + index">
                                                    <b-form-input
                                                        :id="'tattoo-title-' + index"
                                                        v-model="tattoo.title"
                                                        placeholder="e.g. Front Windshield, Driver Door, Rear Window"
                                                    />
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-6 col-12">
                                                <b-form-group
                                                    label="Tattoo Photo:"
                                                    label-class="font-weight-bold"
                                                    description="Recommended size: 300x300px (JPG/PNG)"
                                                >
                                                    <div
                                                        class="border rounded p-3 text-center"
                                                        style="cursor: pointer; background: #f9f9f9;"
                                                        @drop.prevent="onTattooImageDrop($event, index)"
                                                        @dragover.prevent
                                                        @click="triggerTattooInput(index)"
                                                    >
                                                        <template v-if="!tattoo.preview">
                                                            <i class="fas fa-cloud-upload-alt fa-2x text-muted"></i>
                                                            <p class="mb-0">Drag & Drop or Click to Upload</p>
                                                        </template>
                                                        <div v-else class="d-flex flex-wrap justify-content-center">
                                                            <div class="m-1 text-center">
                                                                <img
                                                                    :src="tattoo.preview"
                                                                    alt="Tattoo preview"
                                                                    class="img-thumbnail"
                                                                    style="max-height: 100px; max-width: 100px; object-fit: cover;"
                                                                />
                                                                <b-button
                                                                    size="sm"
                                                                    variant="danger"
                                                                    class="mt-1"
                                                                    @click.stop="removeTattooPhoto(index)"
                                                                >
                                                                    Remove
                                                                </b-button>
                                                            </div>
                                                        </div>
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            class="d-none"
                                                            ref="tattooInputs"
                                                            @change="onTattooImageChange($event, index)"
                                                        />
                                                    </div>
                                                    <b-form-invalid-feedback v-if="tattooImageError" class="d-block text-danger">
                                                        {{ tattooImageError }}
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-2 col-12 d-flex align-items-center pb-3">
                                                <b-button variant="danger" block @click="removeTattoo(index)">Remove Location</b-button>
                                            </div>
                                        </b-row>
                                    </b-card>
                                </div>

                                <div class="col-12 mb-3">
                                    <b-button variant="outline-primary" @click="addTattoo">+ Add Tattoo Location</b-button>
                                </div>

                            <b-modal v-model="showModal" title="Update Document" @hidden="resetModal">
                                <b-form @submit.prevent="updateDocument">
                                    <b-form-group label="Select a new document">
                                        <b-form-file v-model="selectedFile"></b-form-file>
                                    </b-form-group>
                                  <br>
                                    <b-button type="submit" variant="primary"
                                        :disabled="!selectedFile">Update
                                    </b-button>
                                </b-form>
                            </b-modal>

                        </div>

                        <b-button type="submit" variant="primary" class="mb-8 mr-8" :disabled="isLoading">
                            <span v-if="!isLoading">Submit</span>
                            <b-spinner v-else class="mb-8 mr-8" variant="primary" small></b-spinner>
                        </b-button>
                    </b-form>
                </div>
                <div v-if="codeActive" class="col-12 mt-24 hljs-container" :class="{ active: codeActiveClass }">
                    <pre v-highlightjs>
                        <code class="hljs html">{{ codeText }}</code>
                    </pre>
                </div>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BSpinner,
    BToast,
    BFormSelect,
    BFormInvalidFeedback,
} from "bootstrap-vue";
import axios from "../../../axios";
export default {
    data() {
        return {
            show: true,
            codeActive: false,
            options: [],
            isLoading: false,
            brand_model_id: "",
            // company_name: "",
            model: "",
            color: "",
            license_plate: "",
            categories: [],
            brands: [],
            brandModels: [],
            category_id: null,
            brand_id: null,
            filteredBrands: [],
            filteredModels: [],
            types: "",
            registration_number: "",
            vin: "",
            uic: "",
            year: "",
            SystemNo: "",
            engine_number: "",
            status: "safe",
            image: [],
            imageFiles: [],
            imagePreviews: [],
            documents: [],
            documentFiles: [],
            documentPreviews: [],
            editedUser: {},
            successMessage: "",
            features: "",
            description: "",
            statusOptions: [
                { value: null, text: 'Select status of vehicle' },
                { value: 'Pending', text: 'Pending' },
                { value: 'Approved', text: 'Approved' },
                { value: 'Rejected', text: 'Rejected' }
            ],
            showModal: false,
            selectedFile: null,
            selectedIndex: null,
            vehicleImageError: "",
            vehicleDocumentError: "",
            install_date: "",
            insurance_company_name: "",
            insurance_policy_number: "",
            insurance_expiration_date: "",
            tattoos: [],
            deletedTattooIds: [],
            tattooImageError: "",

        };
    },
    components: {
        BRow,
        BCol,
        BCard,
        BButton,
        BForm,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BFormFile,
        BSpinner,
        BToast,
        BFormInvalidFeedback,
    },
    mounted() {
        axios.get('CategoryList')
            .then(response => {
                this.categories = response.data.data.map(category => ({
                    value: category.id,
                    text: category.title
                }));

            })
            .catch(error => {
            });


        axios.get('brandList')
            .then(response => {
                this.brands = response.data.data.map(brand => ({
                    value: brand.id,
                    text: brand.name,
                    categoryId: brand.category_id,
                }));

            })
            .catch(error => {
            });


        axios.get('brandModel')
            .then(response => {

                this.brandModels = response.data.data.map(model => ({
                    value: model.id,
                    text: model.title,
                    brandId: model.brand_id,
                }));

            })
            .catch(error => {
            });
    },

    created() {
        const userId = this.$route.params.id;
        this.type = localStorage.getItem("type");
        const endpoint = this.type === "manager" ? "vehicleShowManager" : "vehicleShow";
        axios
        .get(`${endpoint}/${userId}`)
            .then((response) => {
                const editedUser = response.data.data;
                this.editedUser = editedUser;
                // this.company_name = editedUser.company_name;
                this.category_id = editedUser.category_id;
                this.color = editedUser.color;
                this.license_plate = editedUser.license_plate;
                this.types = editedUser.types;
                this.engine_number = editedUser.engine_number;
                this.image = editedUser.image;
                this.registration_number = editedUser.registration_number;
                this.vin = editedUser.vin;
                this.uic = editedUser.uic;
                this.install_date = editedUser.install_date;
                this.year = editedUser.year;
                this.features = editedUser.features;
                this.SystemNo = editedUser.SystemNo;
                this.insurance_company_name = editedUser.insurance_company_name;
                this.insurance_policy_number = editedUser.insurance_policy_number;
                this.insurance_expiration_date = editedUser.insurance_expiration_date;
                this.description = editedUser.description;
                this.status = editedUser.status;
                this.brand_model_id = this.editedUser.brand_model_id; // Set brand_model_id
                this.brand_id = this.editedUser.brand_id; // Set brand_id

                this.imagePreviews = editedUser.image.map(img => `https://wossdb.wossautoid.com/${img}`);
                this.imageFiles = new Array(editedUser.image.length).fill(null);
                this.documentPreviews = this.editedUser.documents.map(
                    doc => `https://wossdb.wossautoid.com/${doc.documents}`
                );
                this.tattoos = (editedUser.tattoos || []).map(tattoo => ({
                    id: tattoo.id,
                    title: tattoo.title,
                    preview: `https://wossdb.wossautoid.com/${tattoo.image}`,
                    file: null,
                }));
            })
            .catch((error) => {
                console.error("Error fetching vehicle data:", error);
            });
    },
    methods: {
          validateField(value, type = "text") {
            if (value === null || value === undefined || value === "") return null;

            if (type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(value);
            }
            if (type === "number") {
            const regex = /^\+?[0-9 ]+$/; // accepts + and spaces
            return regex.test(value.toString().trim());
            }
            return value.toString().trim().length > 0;
        },
        openDocumentModal(index) {
            this.selectedIndex = index;
            this.selectedFile = null;
            this.showModal = true;
        },

        // Reset modal on close
        resetModal() {
            this.selectedFile = null;
            this.selectedIndex = null;
        },

        // Update document via API
        updateDocument() {
            if (!this.selectedFile || this.selectedIndex === null) return;

            const formData = new FormData();
            formData.append("documents", this.selectedFile);

            const documentId = this.editedUser.documents[this.selectedIndex].id; // Get document ID from API

            axios
                .post(`/documentsUpdate/${documentId}`, formData)
                .then((response) => {
                    // Update preview
                    this.documentPreviews[this.selectedIndex] = URL.createObjectURL(this.selectedFile);

                    this.$bvToast.toast("Document updated successfully!", {
                        title: "Success",
                        variant: "success",
                        solid: true,
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 3000,
                    });

                    this.showModal = false; // Close modal
                })
                .catch((error) => {
                    console.error("Error updating document:", error);
                });
        },

        filterBrands() {
            this.filteredBrands = this.brands.filter(brand => brand.categoryId === this.category_id);
            this.brand_id = null; // Reset brand_id when category changes
            this.filteredModels = []; // Reset models when category changes
        },
        filterModels() {
            this.filteredModels = this.brandModels.filter(model => model.brandId === this.brand_id);
            this.brand_model_id = null; // Reset brand_model_id when brand changes
        },
        onSubmit(event) {
            event.preventDefault();
            alert(JSON.stringify(this.form));
            // debugger
        },
        addUser() {

            this.isLoading = true;
            const formData = new FormData();
            // formData.append("company_name", this.company_name || "");
            formData.append("brand_model_id", this.brand_model_id);
            formData.append("brand_id", this.brand_id);
            formData.append("category_id", this.category_id);
            formData.append("color", this.color);
            formData.append("license_plate", this.license_plate);
            formData.append("types", this.types);
            formData.append("engine_number", this.engine_number);
            formData.append("registration_number", this.registration_number);
            formData.append("vin", this.vin);
            formData.append("uic", this.uic);
            formData.append("year", this.year);
            formData.append("SystemNo", this.SystemNo);
            formData.append("insurance_company_name", this.insurance_company_name);
            formData.append("insurance_policy_number", this.insurance_policy_number);
            formData.append("insurance_expiration_date", this.insurance_expiration_date);
            formData.append("status", this.status);
            formData.append("features", this.features);
            formData.append("description", this.description);
            formData.append("install_date", this.install_date);
            // Append image files
            this.imageFiles.forEach((file, index) => {
                if (file) {
                    formData.append(`image[${index}]`, file);
                }
            });
            // Append document files
            this.documentFiles.forEach((file, index) => {
                formData.append(`document[${index}]`, file);
            });
            this.tattoos.forEach((tattoo, index) => {
                if (!tattoo.title) return;
                formData.append(`tattoos[${index}][title]`, tattoo.title);
                if (tattoo.id) {
                    formData.append(`tattoos[${index}][id]`, tattoo.id);
                }
                if (tattoo.file) {
                    formData.append(`tattoos[${index}][image]`, tattoo.file);
                }
            });
            this.deletedTattooIds.forEach((id) => {
                formData.append("tattoos_delete[]", id);
            });
               this.type = localStorage.getItem("type");
                const endpoint = this.type === "manager" ? "vehicleUpdateManager" : "vehicleUpdate";
            axios
                .post(`${endpoint}/${this.editedUser.id}`, formData)
                .then((response) => {

                    this.$bvToast.toast("Vehicle Update successfully!", {
                        title: "Success",
                        variant: "primary",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 5000,
                    });
                    this.isLoading = false;
                    this.type = localStorage.getItem("type");
                       if (this.type === "manager") {
                       this.$router.push({ name: 'ListManagerVehicle' });
                        }                
                        else {
                        this.$router.push({ name: 'ListVehicle' });
                        }
                })
                // .catch((error) => {
                //     this.isLoading = false;
                //     if (error.response && error.response.data && error.response.data.message === "This System number is already exist") {
                //         this.$bvToast.toast("This System number already exists. Please enter a different number.", { variant: "danger" });
                //         this.loading = false;
                //     } else {
                //         this.$bvToast.toast("Failed to update System No.", { variant: "danger" });
                //         console.error(error);
                //     }
                // })
                .catch((error) => {
                    this.isLoading = false;
                    let errorMessage = "Failed to update vehicle.";
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message; // Show the API message
                    }
                    this.$bvToast.toast(errorMessage, { variant: "danger" });
                    console.error(error);
                })
             
        },

        onProfilePictureChange(event) {
            const files = Array.from(event.target.files);
            files.forEach(file => {
                this.imageFiles.push(file);
                this.imagePreviews.push(URL.createObjectURL(file));
            });
        },

        codeClick() {
            this.codeActive = !this.codeActive;
        },
        onDocumentChange(event) {
            const files = event.target.files;
            this.documentFiles = Array.from(files);  // Store the files in an array for uploading
            this.documentPreviews = this.documentFiles.map((file) => {
                return file.type === 'application/pdf' ? URL.createObjectURL(file) : URL.createObjectURL(file);
            });
        },
        openDocument(preview) {
            window.open(preview, '_blank');
        },
         // === Vehicle Images ===
        onVehicleImagesChange(event) {
            const files = Array.from(event.target.files);
            files.forEach(file => this.addVehicleImage(file));
        },
        onVehicleImageDrop(e) {
            const files = Array.from(e.dataTransfer.files);
            files.forEach(file => this.addVehicleImage(file));
        },
        addVehicleImage(file) {
            if (!file.type.startsWith("image/")) {
            this.vehicleImageError = "Only image files allowed.";
            return;
            }
            if (file.size > 5 * 1024 * 1024) {
            this.vehicleImageError = "Max size per image is 5MB.";
            return;
            }
            this.imageFiles.push(file);
            this.imagePreviews.push(URL.createObjectURL(file));
            this.vehicleImageError = "";
        },
        removeVehicleImage(index) {
            this.imageFiles.splice(index, 1);
            this.imagePreviews.splice(index, 1);
        },

        // === Vehicle Documents ===
        onVehicleDocumentsChange(event) {
            const files = Array.from(event.target.files);
            files.forEach(file => this.addVehicleDocument(file));
        },
        onVehicleDocumentDrop(e) {
            const files = Array.from(e.dataTransfer.files);
            files.forEach(file => this.addVehicleDocument(file));
        },
        addVehicleDocument(file) {
            const allowedTypes = ["application/pdf", "image/png", "image/jpeg"];
            if (!allowedTypes.includes(file.type)) {
            this.vehicleDocumentError = "Only PDF/JPG/PNG allowed.";
            return;
            }
            if (file.size > 10 * 1024 * 1024) {
            this.vehicleDocumentError = "Max size per document is 10MB.";
            return;
            }
            this.documentFiles.push(file);
            this.documentPreviews.push(
            file.type === "application/pdf" ? file.name + ".pdf" : URL.createObjectURL(file)
            );
            this.vehicleDocumentError = "";
        },
        removeVehicleDocument(index) {
            this.documentFiles.splice(index, 1);
            this.documentPreviews.splice(index, 1);
        },

        addTattoo() {
            this.tattoos.push({ title: "", file: null, preview: null });
        },
        removeTattoo(index) {
            const tattoo = this.tattoos[index];
            if (tattoo && tattoo.id) {
                this.deletedTattooIds.push(tattoo.id);
            }
            this.tattoos.splice(index, 1);
        },
        triggerTattooInput(index) {
            const refs = this.$refs.tattooInputs;
            const input = Array.isArray(refs) ? refs[index] : refs;
            if (input) input.click();
        },
        removeTattooPhoto(index) {
            this.tattoos[index].file = null;
            this.tattoos[index].preview = null;
            this.tattooImageError = "";
        },
        addTattooFile(file, index) {
            if (!file.type.startsWith("image/")) {
                this.tattooImageError = "Only image files allowed.";
                return;
            }
            if (file.size > 5 * 1024 * 1024) {
                this.tattooImageError = "Max size per tattoo photo is 5MB.";
                return;
            }
            this.tattoos[index].file = file;
            this.tattoos[index].preview = URL.createObjectURL(file);
            this.tattooImageError = "";
        },
        onTattooImageChange(event, index) {
            const file = event.target.files[0];
            if (file) this.addTattooFile(file, index);
            event.target.value = "";
        },
        onTattooImageDrop(event, index) {
            const file = event.dataTransfer.files[0];
            if (file) this.addTattooFile(file, index);
        },
    }
};
</script>